import React from 'react';
import { Tabs } from '@mui/material';

// Thin wrapper enforcing horizontal-scroll-with-fade behavior on the pill-tab
// pattern duplicated across Analytics.js, LeaveManagement.js, etc. Safe to
// apply universally (not just mobile-gated): variant="scrollable" is inert
// when the tab row already fits its container, so desktop is unaffected.
export default function ScrollableTabs({ children, ...props }) {
  return (
    <Tabs variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile {...props}>
      {children}
    </Tabs>
  );
}
